import { Component, OnInit, OnDestroy, inject } from '@angular/core';
import { Router, NavigationEnd, RouterOutlet } from '@angular/router';
import { CommonModule } from '@angular/common';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { Subscription } from 'rxjs';
import { SidebarService } from '../../core/services/sidebar';
import { LoaderService } from '../../core/services/loader';
import { Header } from './header/header';
import { Sidebar } from '../../layout/main-layout/sidebar/sidebar';
import { SubSidebar } from './sub-sidebar/sub-sidebar';

@Component({
  selector: 'app-main-layout',
  standalone: true,
  imports: [CommonModule, RouterOutlet, ScrollingModule, Header, Sidebar, SubSidebar],
  templateUrl: './main-layout.html',
  styleUrl: './main-layout.scss',
})
export class MainLayout implements OnInit, OnDestroy {
  private readonly sidebarService = inject(SidebarService);
  private readonly loaderService = inject(LoaderService);
  private readonly router = inject(Router);
  private subscription = new Subscription();

  isLoading$ = this.loaderService.isLoading$;
  isMobileMenuOpen = false;
  isDashboardPage = false;

  ngOnInit(): void {
    this.isDashboardPage = this.router.url.includes('dashboard');

    this.subscription.add(
      this.sidebarService.isMobileMenuOpen$.subscribe((open: boolean) => {
        this.isMobileMenuOpen = open;
      })
    );

    this.subscription.add(
      this.router.events.subscribe((event) => {
        if (event instanceof NavigationEnd) {
          this.sidebarService.setMobileMenuOpen(false);
          this.isDashboardPage = this.router.url.includes('dashboard');
        }
      })
    );
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  closeMobileMenu(): void {
    this.sidebarService.setMobileMenuOpen(false);
  }
}

